













import { BButton, BSpinner } from "bootstrap-vue";

export default {
    components: {
        BSpinner,
        BButton,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        variant: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
    },
    emits: ["onButtonClicked"],
};
